



















import { Component, Vue } from 'vue-property-decorator';
import EmployeeDetails from '@/modules/employees/components/EmployeeDetails.vue';
import EmployeeRoles from '@/modules/employees/components/EmployeeRoles.vue';

import Card from '@/components/default/Card.vue';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';

@Component({
  components: {
    EmployeeDetails,
    EmployeeRoles,
    EventLogsTable,
    Card,
  },
})
export default class EmployeeDetailPage extends Vue {

  get historyConfig(): IEventLogQuery {
    return {
      userId: this.id,
    };
  }

  get id() {
    return this.$route.params.id;
  }
}
